export const MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024; // 5MB

export const getFileSizeError = (count: number) =>
  count > 1 ? "Files over 5MB not allowed." : "File over 5MB not allowed.";
